import { MicrosoftXboxControllerBatteryAlertIcon } from './MicrosoftXboxControllerBatteryAlertIcon';

/**
 * author: Austin Andrews
 * id 57F11EDC-2759-4D62-BDD2-C7C3F5199623
 * name microsoft-xbox-controller-battery-alert
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-battery-alert.svg
 * tags
 * - Battery 
 * - Gaming / RPG 
 * - Alert / Error 
 */
export const XboxControllerBatteryWarningIcon = MicrosoftXboxControllerBatteryAlertIcon;
export default XboxControllerBatteryWarningIcon